// extracted by mini-css-extract-plugin
export default {"App-Container":"App_App-Container__nkhL5","appLoading-Container":"App_appLoading-Container__4lHul"};